// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { useProjectImage } from "Content/Shared/Helpers/Functions/Hooks"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

// REDUX
import { ProjectType } from "Redux/Types/ProjectsTypes"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  project: ProjectType
}

const HeaderSection: React.FC<PropsType> = (props) => {
  const { title, type } = props.project
  const image = useProjectImage(title)

  return (
    <>
      <Title>{title}</Title>
      {type}
      <Image src={image} />
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Title = styled.h1`
  font-size: 40px;
  margin-bottom: 10px;
  margin-top: 30px;
`

const Image = styled.img`
  width: 100%;
  margin-top: 30px;
`

export default React.memo(HeaderSection, memoComparison)
